import { getWeek, addDays } from "date-fns";

const weekOpts = { weekStartsOn: 0 as const }; // dimanche = premier jour, aligné avec le backend

export function formatDateByScale(timestamp: number, scale?: string): string {
  const effectiveScale = scale ?? "week";
  const d = new Date(timestamp);
  if (effectiveScale === "month") {
    return d.toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  }
  // week et day : afficher le premier jour du bucket (pour week = le dimanche)
  return d.toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
}

export function formatTooltipByScale(timestamp: number, scale?: string): string {
  const effectiveScale = scale ?? "week";
  const d = new Date(timestamp);
  if (effectiveScale === "month") {
    return d.toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  }
  if (effectiveScale === "week") {
    const weekNum = getWeek(d, weekOpts);
    const firstDay = d.toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
    const lastDay = addDays(d, 6).toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
    return `S${weekNum} - ${firstDay} au ${lastDay}`;
  }
  // day
  return d.toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
}
